import { render, staticRenderFns } from "./AdditionalOwners.vue?vue&type=template&id=0c085b7e&scoped=true&"
import script from "./AdditionalOwners.vue?vue&type=script&lang=js&"
export * from "./AdditionalOwners.vue?vue&type=script&lang=js&"
import style0 from "./AdditionalOwners.vue?vue&type=style&index=0&id=0c085b7e&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c085b7e",
  null
  
)

export default component.exports